import { AboutUsStoreLocationElementDataType } from '@/components/sections/builder/elements/body/store-location/type';
import { ElementProps } from '@/components/sections/builder/types';
import { WrapperChild } from '@/components/sections/builder/wrapper';
import { cn } from '@/lib/utils';

export default function ElementContentAddresses({ element }: ElementProps) {
  const content = element.data as AboutUsStoreLocationElementDataType;
  const childs = element.childs;

  return (
    <>
      <section
        className='theme_layout_page_width color-scheme-address mx-auto w-full duration-100'
        style={{
          paddingTop: content.padding?.top,
          paddingBottom: content.padding?.bottom,
          paddingLeft: content.padding?.left,
          paddingRight: content.padding?.right,
        }}
      >
        <div className='flex flex-col px-4 lg:px-0'>
          <h1 className='mb-6 text-2xl font-medium leading-9'>{content.header}</h1>
          <div
            className={cn(
              `grid gap-8 grid-cols-${content.limitMobile} md:grid-cols-2 lg:grid-cols-${
                content.limit || 3
              } lg:grid-cols-${content.limit || 3}`,
              ((content.limit as number) <= 3 || !content.limit) && 'md:gap-10 lg:gap-20',
              (content.limit as number) > 3 && 'lg:gap-10'
            )}
          >
            {(childs || []).map((child) => (
              <WrapperChild
                child={{
                  ...child,
                  parentData: content,
                }}
                parentType={element.type}
                key={child.id}
              />
            ))}
          </div>
        </div>
      </section>
      <style jsx>
        {`
          .color-scheme-address {
            color: ${content.colorScheme?.text};
            background-color: ${content.colorScheme?.background};
          }
        `}
      </style>
    </>
  );
}
